import { getLang, getUrlBasedOnCountry, isDeviceMobile } from "../../../Helpers/functions";
import { ShowMore, ShowMorePayload } from "../widgets.types";

function buildShowMoreUrl(payload: ShowMorePayload): string {
  const { form, cta, cartId, Payment, landOn, initShowMore } = payload;
  const { modelId, actionSource, posSource } = Payment;

  const lang = getLang();
  const base = getUrlBasedOnCountry("add", "");

  return (
    base +
    `?flow=promoteFlow` +
    `&v=2` +
    `&source=${isDeviceMobile() ? "mobile" : "desktop"}` +
    `&lang=${lang}` +
    `&actionSource=${encodeURIComponent(actionSource)}` +
    `&pos=${encodeURIComponent(posSource)}` +
    `&post_id=${modelId}` +
    (form ? `&form=${encodeURIComponent(form)}` : "") +
    (landOn ? `&landOn=${encodeURIComponent(landOn)}` : "") +
    (initShowMore ? `&initShowMore=${encodeURIComponent(initShowMore)}` : "") +
    `&cta=${encodeURIComponent(cta)}` +
    `&cartId=${cartId}` +
    `&from=opensooq-payment` +
    `&return=${encodeURIComponent(window.location.href)}`
  );
}

export default function ShowMoreCard({
  showMore,
  anyItemHasOldPrice,
}: {
  showMore: ShowMore;
  anyItemHasOldPrice: boolean;
}) {
  const handleClick = () => {
    const url = buildShowMoreUrl(showMore.payload);
    // console.log("showMore url:", url);
    window.location.href = url;
  };

  return (
    <div
      className="widget-card d-flex flex-column align-items-center justify-content-center rounded-3 position-relative"
      style={{
        background: showMore.backgroundColor,
        border: `1px solid ${showMore.borderColor}`,
        width: 106,
        height: anyItemHasOldPrice ? 180 : 165,
        marginTop: 32,
        cursor: "pointer",
        flexShrink: 0,
      }}
      onClick={handleClick}
    >
      <span
        className={`text-center text-12 ${showMore.title.style.bold ? "fw-bold" : ""}`}
        style={{ color: showMore.title.style.textColor }}
      >
        {showMore.title.text}
      </span>
    </div>
  );
}
